import React from 'react'
import styled from 'styled-components'
import CaretIcon from 'images/caret.svg'

const Label = styled.label`
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 12px;
`

const Caret = styled(CaretIcon)`
  width: 20px;
  &.open {
    transform: rotate(180deg);
  }
`

const FormField = ({
  text,
  isCategoryOpen,
  isCaretVisible = false,
  onToggleCategory,
}) => (
  <Label onClick={onToggleCategory}>
    {text} {isCaretVisible && <Caret className={isCategoryOpen && 'open'} />}
  </Label>
)

export default FormField
